// Components==============
import { faCog, faEnvelope, faEye } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Avatar from 'components/UI/Avatar/Avatar';
import Tooltip from 'components/UI/Tooltip/Tooltip';
import { TooltipContext } from 'components/UI/Tooltip/TooltipContextWrapper';
import { AnimatePresence } from 'framer-motion';
import { usePermission } from 'hooks/usePermission';
import { useRedux } from 'hooks/useRedux';
import { useTranslate } from 'hooks/useTranslate';
import { ProjectDetailsContext } from 'pages/Workspace/ProjectDetails/ProjectDetails';
import React, { useContext, useState } from 'react';
import DeleteMemberModal from '../Modals/DeleteMemberModal/DeleteMemberModal';
import './Member.module.scss';
// =========================

export default function Member({ member }: { member: ProjectMemberEntity }) {
  const translate = useTranslate();

  const { userMembership, handleAddAdmin, handleDeleteAdmin } = useContext(
    ProjectDetailsContext
  );
  const userId = useRedux((state) => state.authentication?.user?.id);
  const isTeacher = usePermission(['Docent', 'super-admin']);

  const teacherInProjectWithOtherTeachers =
    member.membership === 'admin' && isTeacher;

  const hasTooltipMenu =
    (userMembership === 'admin' || userMembership === 'owner') &&
    member.membership !== 'owner' &&
    member.membership !== 'teacher' &&
    !teacherInProjectWithOtherTeachers;

  const { setTooltipIsVisible } = useContext(TooltipContext);

  const [deleteModalIsOpen, setDeleteModalIsOpen] = useState(false);

  return (
    <>
      <div style={{ height: 35 }}>
        <Tooltip
          content={
            <div styleName="tooltip">
              <p>
                {member.user.first_name} {member.user.last_name}
              </p>
              {!!(member.membership === 'admin') && (
                <span>{translate('project.terms.admin')}</span>
              )}
              {!!(member.membership === 'invited') && (
                <span>{translate('project.terms.invited')}</span>
              )}
              {!!(member.membership === 'teacher') && (
                <span>{translate('project.terms.teacher')}</span>
              )}
              {!!(member.membership === 'extern') && (
                <span>{translate('project.terms.extern')}</span>
              )}
              {!!(member.membership === 'owner') && (
                <span>{translate('project.terms.owner')}</span>
              )}
            </div>
          }
          clickContent={
            hasTooltipMenu ? (
              <div styleName="tooltip-menu">
                {!!(member?.membership === 'member') && (
                  <button
                    onClick={() => {
                      handleAddAdmin(member.id);
                      setTooltipIsVisible(false);
                    }}
                    type="button"
                  >
                    {translate('project.actions.add-admin')}
                  </button>
                )}

                {!!(member?.membership === 'admin') && (
                  <button
                    onClick={() => {
                      handleDeleteAdmin(member.id);
                      setTooltipIsVisible(false);
                    }}
                    type="button"
                  >
                    {translate('project.actions.remove-admin')}
                  </button>
                )}
                {!!(member?.user.id !== userId) && (
                  <button
                    style={{ color: '#ed1d71' }}
                    onClick={() => {
                      setDeleteModalIsOpen(true);
                      setTooltipIsVisible(false);
                    }}
                    type="button"
                  >
                    {translate(
                      `project.actions.${
                        member.membership === 'invited'
                          ? 'retrieve-invitation'
                          : 'remove-from-group'
                      }`
                    )}
                  </button>
                )}
              </div>
            ) : undefined
          }
        >
          <Avatar user={member.user} />
          {!!hasTooltipMenu && (
            <div styleName="settings">
              <FontAwesomeIcon icon={faCog} />
            </div>
          )}
          {!!(member.membership === 'invited') && (
            <div styleName="invited">
              <FontAwesomeIcon icon={faEnvelope} />
            </div>
          )}
          {!!(
            member.membership === 'teacher' || member.membership === 'extern'
          ) && (
            <div styleName="invited">
              <FontAwesomeIcon icon={faEye} />
            </div>
          )}
        </Tooltip>
      </div>
      <AnimatePresence>
        {deleteModalIsOpen && (
          <DeleteMemberModal
            setModalIsOpen={setDeleteModalIsOpen}
            member={member}
          />
        )}
      </AnimatePresence>
    </>
  );
}
